export const 포켓몬을 = [
  '이상해씨',
  '이상해풀',
  '이상해꽃',
  '파이리',
  '리자드',
  '리자몽',
  '꼬부기',
  '어니부기',
  '거북왕',
  '캐터피',
  '단데기',
  '버터플',
  '뿔충이',
  '딱충이',
  '독침붕',
  '구구',
  '피죤',
  '피죤투',
  '꼬렛',
  '레트라',
  '깨비참',
  '깨비드릴조',
  '아보',
  '아보크',
  '피카츄',
  '라이츄',
  '모래두지',
  '고지',
  '니드런',
  '니드리나',
  '니드퀸',
  '니드리노',
  '니드킹',
  '삐삐',
  '픽시',
  '식스테일',
  '나인테일',
  '푸린',
  '푸크린',
  '주뱃',
  '골뱃',
  '뚜벅쵸',
  '냄새꼬',
  '라플레시아',
  '파라스',
  '파라섹트',
  '콘팡',
  '도나리',
  '디그다',
  '닥트리오',
  '나옹',
  '페르시온',
  '고라파덕',
  '골덕',
  '망키',
  '성원숭',
  '가디',
  '윈디',
  '발챙이',
  '슈륙챙이',
  '강챙이',
  '캐이시',
  '윤겔라',
  '후딘',
  '알통몬',
  '근육몬',
  '괴력몬',
  '모다피',
  '우츠동',
  '우츠보트',
  '왕눈해',
  '독파리',
  '꼬마돌',
  '데구리',
  '딱구리',
  '포니타',
  '날쌩마',
  '야돈',
  '야도란',
  '코일',
  '레어코일',
  '파오리',
  '두두',
  '두트리오',
  '쥬쥬',
  '쥬레곤',
  '질퍽이',
  '질뻐기',
  '셀러',
  '파르셀',
  '고오스',
  '고우스트',
  '팬텀',
  '롱스톤',
  '슬리프',
  '슬리퍼',
  '크랩',
  '킹크랩',
  '찌리리공',
  '붐볼',
  '아라리',
  '나시',
  '탕구리',
  '텅구리',
  '시라소몬',
  '홍수몬',
  '내루미',
  '또가스',
  '또도가스',
  '뿔카노',
  '코뿌리',
  '럭키',
  '덩쿠리',
  '캥카',
  '쏘드라',
  '시드라',
  '콘치',
  '왕콘치',
  '별가사리',
  '아쿠스타',
  '마임맨',
  '스라크',
  '루주라',
  '에레브',
  '마그마',
  '쁘사이저',
  '켄타로스',
  '잉어킹',
  '갸라도스',
  '라프라스',
  '메타몽',
  '이브이',
  '샤미드',
  '쥬피썬더',
  '부스터',
  '폴리곤',
  '암나이트',
  '암스타',
  '투구',
  '투구푸스',
  '프테라',
  '잠만보',
  '프리져',
  '썬더',
  '파이어',
  '미뇽',
  '신뇽',
  '망나뇽',
  '뮤츠',
  '뮤',
  '치코리타',
  '베이리프',
  '메가니움',
  '브케인',
  '마그케인',
  '블레이범',
  '리아코',
  '엘리게이',
  '장크로다일',
  '꼬리선',
  '다꼬리',
  '부우부',
  '야부엉',
  '레디바',
  '레디안',
  '페이검',
  '아리아도스',
  '크로뱃',
  '초라기',
  '랜턴',
  '피츄',
  '삐',
  '푸푸린',
  '토게피',
  '토게틱',
  '네이티',
  '네이티오',
  '메리프',
  '보송송',
  '전룡',
  '아르코',
  '마릴',
  '마릴리',
  '꼬지모',
  '왕구리',
  '통통코',
  '두코',
  '솜솜코',
  '에이팜',
  '해너츠',
  '해루미',
  '왕자리',
  '우파',
  '누오',
  '에브이',
  '블래키',
  '니로우',
  '야도킹',
  '무우마',
  '안농',
  '마자용',
  '키링키',
  '피콘',
  '쏘콘',
  '노고치',
  '글라이거',
  '강철톤',
  '블루',
  '그랑블루',
  '침바루',
  '핫삼',
  '단단지',
  '헤라크로스',
  '포푸니',
  '깜지곰',
  '링곰',
  '마그마그',
  '마그카르고',
  '꾸꾸리',
  '메꾸리',
  '코산호',
  '총어',
  '대포무노',
  '딜리버드',
  '만타인',
  '무장조',
  '델빌',
  '헬가',
  '킹드라',
  '코코리',
  '코리갑',
  '폴리곤2',
  '노라키',
  '루브도',
  '배루키',
  '카포에라',
  '뽀뽀라',
  '에레키드',
  '마그비',
  '밀탱크',
  '해피너스',
  '라이코',
  '앤테이',
  '스이쿤',
  '애버라스',
  '데기라스',
  '마기라스',
  '루기아',
  '칠색조',
  '세레비',
  '나무지기',
  '나무돌이',
  '나무킹',
  '아차모',
  '영치코',
  '번치코',
  '물짱이',
  '늪짱이',
  '대짱이',
  '포챠나',
  '그라에나',
  '지그제구리',
  '직구리',
  '개무소',
  '실쿤',
  '뷰티플라이',
  '카스쿤',
  '독케일',
  '연꽃몬',
  '로토스',
  '로파파',
  '도토링',
  '잎새코',
  '다탱구',
  '테일로',
  '스왈로',
  '갈모매',
  '패리퍼',
  '랄토스',
  '킬리아',
  '가디안',
  '비구술',
  '비나방',
  '버섯꼬',
  '버섯모',
  '게을로',
  '발바로',
  '게을킹',
  '토중몬',
  '아이스크',
  '껍질몬',
  '소곤룡',
  '노공룡',
  '폭음룡',
  '마크탕',
  '하리뭉',
  '루리리',
  '코코파스',
  '에나비',
  '델케티',
  '깜까미',
  '입치트',
  '가보리',
  '갱도라',
  '보스로라',
  '요가랑',
  '요가램',
  '썬더라이',
  '썬더볼트',
  '플러시',
  '마이농',
  '볼비트',
  '네오비트',
  '로젤리아',
  '꼴깍몬',
  '꿀꺽몬',
  '샤프니아',
  '샤크니아',
  '고래왕자',
  '고래왕',
  '둔타',
  '폭타',
  '코터스',
  '피그점프',
  '피그킹',
  '얼루기',
  '톱치',
  '비브라바',
  '플라이곤',
  '선인왕',
  '밤선인',
  '파비코',
  '파비코리',
  '쟝고',
  '세비퍼',
  '루나톤',
  '솔록',
  '미꾸리',
  '메깅',
  '가재군',
  '가재장군',
  '오뚝군',
  '점토도리',
  '릴링',
  '릴리요',
  '아노딥스',
  '아말도',
  '빈티나',
  '밀로틱',
  '캐스퐁',
  '켈리몬',
  '어둠대신',
  '다크펫',
  '해골몽',
  '미라몽',
  '트로피우스',
  '치렁',
  '앱솔',
  '마자',
  '눈꼬마',
  '얼음귀신',
  '대굴레오',
  '씨레오',
  '씨카이저',
  '진주몽',
  '헌테일',
  '분홍장이',
  '시라칸',
  '사랑동이',
  '아공이',
  '쉘곤',
  '보만다',
  '메탕',
  '메탕구',
  '메타그로스',
  '레지락',
  '레지아이스',
  '레지스틸',
  '라티아스 ',
  '라티오스',
  '가이오가',
  '그란돈',
  '레쿠쟈',
  '지라치',
  '테오키스',
  '모부기',
  '수풀부기',
  '토대부기',
  '불꽃숭이',
  '파이숭이',
  '초염몽',
  '팽도리',
  '팽태자',
  '엠페르트',
  '찌르꼬',
  '찌르버드',
  '찌르호크',
  '비버니',
  '비버통',
  '귀뚤뚜기',
  '귀뚤톡크',
  '꼬링크',
  '럭시오',
  '렌트라',
  '꼬몽울',
  '로즈레이드',
  '두개도스',
  '램펄드',
  '방패톱스',
  '바리톱스',
  '도롱충이',
  '도롱마담',
  '나메일',
  '세꿀버리',
  '비퀸',
  '파치리스',
  '브이젤',
  '플로젤',
  '체리버',
  '체리꼬',
  '깝질무',
  '트리토돈',
  '겟핸보숭',
  '흔들풍손',
  '둥실라이드',
  '이어롤',
  '이어롭',
  '무우마직',
  '돈크로우',
  '나옹마',
  '몬냥이',
  '랑딸랑',
  '스컹뿡',
  '스컹탱크',
  '동미러',
  '동탁군',
  '꼬지지',
  '흉내내',
  '핑복',
  '페라페',
  '화강돌',
  '딥상어동',
  '한바이트',
  '한카리아스',
  '먹고자',
  '리오르',
  '루카리오',
  '히포포타스',
  '하마돈',
  '스콜피',
  '드래피온',
  '삐딱구리',
  '독개굴',
  '무스틈니',
  '형광어',
  '네오라이트',
  '타만타',
  '눈쓰개',
  '눈설왕',
  '포푸니라',
  '자포코일',
  '내룸벨트',
  '거대코뿌리',
  '덩쿠림보',
  '에레키블',
  '마그마번',
  '토게키스',
  '메가자리',
  '리피아',
  '글레이시아',
  '글라이온',
  '맘모꾸리',
  '폴리곤Z',
  '엘레이드',
  '대코파스',
  '야느와르몽',
  '눈여아',
  '로토무',
  '유크시',
  '엠라이트',
  '아그놈',
  '디아루가',
  '펄기아',
  '히드런',
  '레지기가스',
  '기라티나',
  '크레세리아',
  '피오네',
  '마나피',
  '다크라이',
  '쉐이미',
  '아르세우스',
  '비크티니',
  '주리비얀',
  '샤비',
  '샤로다',
  '뚜꾸리',
  '챠오꿀',
  '염무왕',
  '수댕이',
  '쌍검자비',
  '대검귀',
  '보르쥐',
  '보르그',
  '요테리',
  '하데리어',
  '바랜드',
  '쌔비냥',
  '레파르다스',
  '야나프',
  '야나키',
  '바오프',
  '바오키',
  '앗차프',
  '앗차키',
  '몽나',
  '몽얌나',
  '콩둘기',
  '유토브',
  '켄호로우',
  '줄뮤마',
  '제브라이카',
  '단굴',
  '암트르',
  '기가이어스',
  '또르박쥐',
  '맘박쥐',
  '두더류',
  '몰드류',
  '다부니',
  '으랏차',
  '토쇠골',
  '노보청',
  '동챙이',
  '두까비',
  '두빅굴',
  '던지미',
  '타격귀',
  '두르보',
  '두르쿤',
  '모아머',
  '마디네',
  '휠구',
  '펜드라',
  '소미안',
  '엘풍',
  '치릴리',
  '드레디어',
  '배쓰나이',
  '깜눈크',
  '악비르',
  '악비아르',
  '달막화',
  '불비달마',
  '마라카치',
  '돌살이',
  '암팰리스',
  '곤율랭',
  '곤율거니',
  '심보러',
  '데스마스',
  '데스니칸',
  '프로토가',
  '늑골라',
  '아켄',
  '아케오스',
  '깨봉이',
  '더스트나',
  '조로아',
  '조로아크',
  '치라미',
  '치라치노',
  '고디탱',
  '고디보미',
  '고디모아젤',
  '유니란',
  '듀란',
  '란쿨루스',
  '꼬지보리',
  '스완나',
  '바닐프티',
  '바닐리치',
  '배바닐라',
  '사철록',
  '바라철록',
  '에몽가',
  '딱정곤',
  '슈바르고',
  '깜놀버슬',
  '뽀록나',
  '탱그릴',
  '탱탱겔',
  '맘복치',
  '파쪼옥',
  '전툴라',
  '철시드',
  '너트령',
  '기어르',
  '기기어르',
  '기기기어르',
  '저리어',
  '저리릴',
  '저리더프',
  '리그레',
  '벰크',
  '불켜미',
  '램프라',
  '샹델라',
  '터검니',
  '액슨도',
  '액스라이즈',
  '코고미',
  '툰베어',
  '프리지오',
  '쪼마리',
  '어지리더',
  '메더',
  '비조푸',
  '비조도',
  '크리만',
  '골비람',
  '골루그',
  '자망칼',
  '절각참',
  '버프론',
  '수리둥보',
  '워글',
  '벌차이',
  '버랜지나',
  '앤티골',
  '아이앤트',
  '모노두',
  '디헤드',
  '삼삼드래',
  '활화르바',
  '불카모스',
  '코바르온',
  '테라키온',
  '비리디온',
  '토네로스',
  '볼트로스',
  '레시라무',
  '제크로무',
  '랜드로스',
  '큐레무',
  '케르디오',
  '메로엣타',
  '게노세크트',
  '도치마론',
  '도치보구',
  '브리가론',
  '푸호꼬',
  '테르나',
  '마폭시',
  '개구마르',
  '개굴반장',
  '개굴닌자',
  '파르빗',
  '파르토',
  '화살꼬빈',
  '불화살빈',
  '파이어로',
  '분이벌레',
  '분떠도리',
  '비비용',
  '레오꼬',
  '화염레오',
  '플라베베',
  '플라엣테',
  '플라제스',
  '메이클',
  '고고트',
  '판짱',
  '부란다',
  '트리미앙',
  '냐스퍼',
  '냐오닉스',
  '단칼빙',
  '쌍검킬',
  '킬가르도',
  '슈쁘',
  '프레프티르',
  '나룸퍼프',
  '나루림',
  '오케이징',
  '칼라마네로',
  '거북손손',
  '거북손데스',
  '수레기',
  '드래캄',
  '완철포',
  '블로스터',
  '목도리키텔',
  '일레도리자드',
  '티고라스',
  '견고라스',
  '아마루스',
  '아마루르가',
  '님피아',
  '루차불',
  '데덴네',
  '멜리시',
  '미끄메라',
  '미끄네일',
  '미끄래곤',
  '클레피',
  '나목령',
  '대로트',
  '호바귀',
  '펌킨인',
  '꽁어름',
  '크레베이스',
  '음뱃',
  '음번',
  '제르네아스',
  '이벨타르',
  '지가르데',
  '디안시',
  '후파',
  '볼케니온',
  '나몰빼미',
  '빼미스로우',
  '모크나이퍼',
  '냐오불',
  '냐오히트',
  '어흥염',
  '누리공',
  '키요공',
  '누리레느',
  '콕코구리',
  '크라파',
  '왕큰부리',
  '영구스',
  '형사구스',
  '턱지충이',
  '전지충이',
  '투구뿌논',
  '오기지게',
  '모단단게',
  '춤추새',
  '에블리',
  '에리본',
  '암멍이',
  '루가루암',
  '약어리',
  '시마사리',
  '더시마사리',
  '머드나기',
  '만마드',
  '물거미',
  '깨비물거미',
  '짜랑랑',
  '라란티스',
  '자마슈',
  '마셰이드',
  '야도뇽',
  '염뉴트',
  '포곰곰',
  '이븐곰',
  '달콤아',
  '달무리나',
  '달코퀸',
  '큐아링',
  '하랑우탄',
  '내던숭이',
  '꼬시레',
  '갑주무사',
  '모래꿍',
  '모래성이당',
  '해무기',
  '타입:널',
  '실버디',
  '메테노',
  '자말라',
  '폭거북스',
  '토게데마루',
  '따라큐',
  '치갈기',
  '할비롱',
  '타타륜',
  '짜랑꼬',
  '짜랑고우',
  '짜랑고우거',
  '카푸꼬꼬꼭',
  '카푸나비나',
  '카푸브루루',
  '카푸느지느',
  '코스모그',
  '코스모움',
  '솔가레오',
  '루나아라',
  '텅비드',
  '매시붕',
  '페로코체',
  '전수목',
  '철화구야',
  '종이신도',
  '악식킹',
  '네크로즈마',
  '마기아나',
  '마샤도',
  '베베놈',
  '아고용',
  '차곡차곡',
  '두파팡',
  '제라오라',
  '멜탄',
  '멜메탈',
  '흥나숭',
  '채키몽',
  '고릴타',
  '염버니',
  '래비풋',
  '에이스번',
  '울머기',
  '누겔레온',
  '인텔리레온',
  '탐리스',
  '요씽리스',
  '파라꼬',
  '파크로우',
  '아머까오',
  '두루지벌레',
  '레돔벌레',
  '이올브',
  '훔처우',
  '폭슬라이',
  '꼬모카',
  '백솜모카',
  '우르',
  '배우르',
  '깨물부기',
  '갈가부기',
  '멍파치',
  '펄스멍',
  '탄동',
  '탄차곤',
  '석탄산',
  '과사삭벌레',
  '애프룡',
  '단지래플',
  '모래뱀',
  '사다이사',
  '윽우지',
  '찌로꼬치',
  '꼬치조',
  '일레즌',
  '스트린더',
  '태우지네',
  '다태우지네',
  '때때무노',
  '케오퍼스',
  '데인차',
  '포트데스',
  '몸지브림',
  '손지브림',
  '브리무음',
  '메롱꿍',
  '쏘겨모',
  '오롱털',
  '가로막구리',
  '나이킹',
  '산호르곤',
  '창파나이트',
  '마임꽁꽁',
  '데스판',
  '마빌크',
  '마휘핑',
  '대여르',
  '찌르성게',
  '누니머기',
  '모스노우',
  '돌헨진',
  '빙큐보',
  '에써르',
  '모르페코',
  '끼리동',
  '대왕끼리동',
  '파치래곤',
  '파치르돈',
  '어래곤',
  '어치르돈',
  '두랄루돈',
  '드라꼰',
  '드래런치',
  '드래펄트',
  '자시안',
  '자마젠타',
  '무한다이노',
  '치고마',
  '우라오스',
  '자루도',
  '레지에레키',
  '레지드래고',
  '블리자포스',
  '레이스포스',
  '버드렉스',
  '신비록',
  '사마자르',
  '다투곰',
  '대쓰여너',
  '포푸니크',
  '장침바루',
  '러브로스',
  '나오하',
  '나로테',
  '마스카나',
  '뜨아거',
  '악뜨거',
  '라우드본',
  '꾸왁스',
  '아꾸왁',
  '웨이니발',
  '맛보돈',
  '퍼퓨돈',
  '노고고치',
  '타랜툴라',
  '트래피더',
  '콩알뚜기',
  '엑스레그',
  '구르데',
  '베라카스',
  '망망이',
  '묘두기',
  '하느라기',
  '클레스퍼트라',
  '키키링',
  '바다그다',
  '바닥트리오',
  '어써러셔',
  '가비루사',
  '맨돌핀',
  '돌핀맨',
  '미니브',
  '올리뇨',
  '올리르바',
  '캡싸이',
  '스코빌런',
  '빈나두',
  '찌리배리',
  '부르롱',
  '부르르룸',
  '꿈트렁',
  '두리쥐',
  '파밀리쥐',
  '터벅고래',
  '우락고래',
  '드니차',
  '드니꽁',
  '드닐레이브',
  '싸리용',
  '모토마',
  '빠모',
  '빠모트',
  '빠르모트',
  '찌리비',
  '찌리비크',
  '떨구새',
  '시비꼬',
  '꼬이밍고',
  '절벼게',
  '베베솔트',
  '스태솔트',
  '콜로솔트',
  '초롱순',
  '킬라플로르',
  '땃쭈르',
  '태깅구르',
  '쫀도기',
  '바우첼',
  '오라티프',
  '마피티프',
  '그푸리',
  '공푸리',
  '모으령',
  '타부자고',
  '위대한엄니',
  '사나운버섯',
  '모래털가죽',
  '우렁찬꼬리',
  '날개치는머리',
  '땅을기는날개',
  '고동치는달',
  '무쇠바퀴',
  '무쇠독나방',
  '무쇠손',
  '무쇠머리',
  '무쇠가시',
  '무쇠보따리',
  '무쇠무인',
  '딩루',
  '파오젠',
  '총지엔',
  '위유이',
  '코라이돈',
  '미라이돈',
  '어리짱',
  '벼리짱',
  '두드리짱',
  '카르본',
  '카디나르마',
  '파라블레이즈',
  '들눈해',
  '육파리',
  '대도각참',
  '토오',
  '저승갓숭',
];
